{
  "user": {
    "form": {
      "addTitle": "사용자 생성",
      "editTitle": "사용자 편집",
      "fields": {
        "username": "사용자 이름",
        "email": "이메일",
        "fullName": "성명",
        "password": "비밀번호",
        "confirmPassword": "비밀번호 확인",
        "facility": "기관",
        "roles": "역할",
        "active": "활성",
        "allFacilities": "전체 시설(헬스시스템 전체)",
        "globalAccessAck": "모든 시설에 대한 접근 권한이 부여됨을 이해합니다",
        "departments": "부서",
        "primaryDepartment": "주 부서",
        "roleFacility": "{{role}}의 시설",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ 시설 추가",
        "removeFacilityFromRole": "하나 제거",
        "otherRoles": "기타"
      },
      "errors": {
        "usernameMin": "사용자 이름은 {{min}}자 이상이어야 합니다",
        "emailInvalid": "이메일 주소 형식이 올바르지 않습니다",
        "passwordMin": "비밀번호는 {{min}}자 이상이어야 합니다",
        "confirmPasswordRequired": "비밀번호를 다시 입력해 주십시오",
        "passwordMismatch": "비밀번호가 일치하지 않습니다",
        "rolesRequired": "최소 한 개 이상의 역할을 선택해야 합니다",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "저장하기 전에 헬스시스템 전체 권한을 확인하세요."
      },
      "submit": {
        "create": "사용자 생성",
        "update": "사용자 업데이트"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "사용자가 생성되었습니다",
        "updatedSuccess": "사용자가 업데이트되었습니다",
        "saveError": "사용자 저장에 실패하였습니다",
        "departmentsSaveError": "사용자는 저장되었지만 부서 배정에 실패했습니다. 사용자를 편집하여 다시 시도하세요."
      },
      "globalAccessWarning": "호출 범위뿐 아니라 '모든' 시설의 환자에 대한 접근 권한이 부여됩니다. 온콜 담당 등 실제로 헬스시스템 전체를 담당하는 직원에게만 사용하세요.",
      "departmentsHint": "이 계정이 근무하는 부서입니다. 기록 귀속에만 사용되며 환자 접근 권한은 부여하지 않습니다.",
      "noDepartments": "구성된 부서가 없습니다."
    },
    "list": {
      "title": "사용자 관리",
      "subtitle": "시스템 사용자, 역할, 액세스 권한 관리",
      "columns": {
        "username": "사용자명",
        "fullName": "성명",
        "email": "이메일",
        "roles": "역할",
        "facility": "시설",
        "status": "상태",
        "lastLogin": "마지막 로그인",
        "actions": "작업",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "사용자 검색...",
        "allRoles": "모든 역할",
        "allFacilities": "모든 시설",
        "allStatus": "모든 상태",
        "active": "활성",
        "inactive": "비활성"
      },
      "actions": {
        "new": "사용자 생성",
        "editTitle": "사용자 편집",
        "resetPasswordTitle": "비밀번호 재설정",
        "activate": "활성화",
        "deactivate": "비활성화",
        "activateAria": "사용자 활성화",
        "deactivateAria": "사용자 비활성화"
      },
      "lastLoginNever": "없음",
      "empty": "필터 조건에 맞는 사용자가 없습니다",
      "pagination": {
        "summary": "{{total}} 중 {{from}}-{{to}} 표시"
      },
      "toast": {
        "activated": "사용자 {{username}}가 활성화되었습니다",
        "deactivated": "사용자 {{username}}가 비활성화되었습니다",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "전체 시설",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "활성",
      "inactive": "비활성",
      "locked": "잠김",
      "pendingActivation": "활성화 대기"
    },
    "mfaStatus": {
      "enrolled": "등록됨",
      "notEnrolled": "미등록",
      "exempt": "면제"
    }
  },
  "role": {
    "form": {
      "addTitle": "역할 생성",
      "editTitle": "역할 편집",
      "fields": {
        "name": "역할 이름",
        "code": "역할 코드",
        "description": "설명",
        "category": "카테고리",
        "parentRole": "상위 역할 (권한 상속)"
      },
      "options": {
        "none": "없음"
      },
      "errors": {
        "nameRequired": "역할 이름을 입력해 주십시오",
        "codeRequired": "역할 코드를 입력해 주십시오"
      },
      "submit": {
        "create": "역할 생성",
        "update": "역할 업데이트"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "역할이 생성되었습니다",
        "updatedSuccess": "역할이 업데이트되었습니다",
        "saveError": "역할 저장에 실패하였습니다"
      }
    },
    
    "status": {
      "active": "활성",
      "inactive": "비활성"
    },
    "source": {
      "own": "자체",
      "inherited": "상속",
      "category": "카테고리"
    },
    "permissions": {
      "ownTitle": "권한 편집",
      "deniedTitle": "거부 권한 편집",
      "ownSubtitle": "{{total}}개 중 {{granted}}개 부여. 상속 및 카테고리 기본 권한은 접근 매트릭스에 표시됩니다. 이 페이지에서는 역할 자체의 부여만 관리합니다.",
      "deniedSubtitle": "거부 권한은 역할 자체, 상위 역할 및 카테고리 기본값의 모든 부여를 무효화합니다. 권한을 선택하여 이 역할에 대해 명시적으로 거부하십시오.",
      "invalidRoleId": "역할 ID가 유효하지 않습니다.",
      "save": "권한 저장",
      "saveDenied": "거부 권한 저장",
      "cancel": "취소",
      "toast": {
        "updatedSuccess": "권한이 업데이트되었습니다",
        "deniedUpdatedSuccess": "거부 권한이 업데이트되었습니다",
        "saveError": "권한 저장에 실패하였습니다",
        "saveDeniedError": "거부 권한 저장에 실패하였습니다"
      },
      "permissionGroup": {
        "analytics": "분석",
        "audit": "감사",
        "billing": "청구",
        "bloodProduct": "혈액제제",
        "consent": "동의",
        "dietOrder": "식이 처방",
        "discharge": "퇴원",
        "documentation": "기록",
        "encounter": "진료",
        "infection": "감염 관리",
        "licensing": "라이선스",
        "medication": "약물",
        "notification": "알림",
        "order": "처방",
        "patient": "환자",
        "referral": "의뢰",
        "research": "연구",
        "restraint": "신체 억제",
        "result": "검사 결과",
        "scheduling": "스케줄",
        "system": "시스템",
        "transfer": "전동",
        "user": "사용자",
        "schedule": "스케줄",
        "admin": "관리",
        "report": "보고서",
        "other": "기타"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "카테고리 생성",
      "editTitle": "카테고리 편집",
      "fields": {
        "name": "카테고리 이름",
        "code": "카테고리 코드",
        "description": "설명",
        "sessionTimeout": "세션 시간 초과 (분)",
        "maxFailedLogins": "최대 로그인 실패 횟수",
        "mfaRequired": "이 카테고리에 MFA 필수"
      },
      "placeholders": {
        "code": "예: CLINICAL"
      },
      "errors": {
        "nameRequired": "카테고리 이름은 필수입니다",
        "codeRequired": "카테고리 코드는 필수입니다"
      },
      "submit": {
        "create": "카테고리 생성",
        "update": "카테고리 업데이트"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "카테고리가 생성되었습니다",
        "updatedSuccess": "카테고리가 업데이트되었습니다",
        "saveError": "카테고리 저장 실패"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "없음",
      "basic": "기본",
      "full": "전체",
      "paranoid": "엄격"
    },
    "permissions": {
      "title": "기본 권한",
      "titleWithName": "기본 권한 — {{name}}",
      "subtitle": "이 카테고리의 역할은 명시적으로 거부하지 않는 한 이러한 권한을 상속합니다.",
      "invalidCategoryId": "카테고리 ID가 유효하지 않습니다.",
      "save": "기본 권한 저장",
      "cancel": "취소",
      "toast": {
        "updatedSuccess": "기본 권한이 업데이트되었습니다",
        "saveError": "기본 권한 저장 실패"
      }
    }
  },
  "permission": {
    "action": {
      "view": "조회",
      "viewSelf": "본인만 조회",
      "viewRestricted": "제한 조회",
      "read": "읽기",
      "write": "쓰기",
      "create": "생성",
      "update": "수정",
      "modify": "변경",
      "delete": "삭제",
      "merge": "병합",
      "discharge": "퇴원",
      "transfer": "전동",
      "approve": "승인",
      "cosign": "공동 서명",
      "sign": "서명",
      "plan": "계획",
      "manage": "관리",
      "all": "전체",
      "breakGlass": "긴급 접근",
      "export": "내보내기",
      "amend": "수정",
      "administer": "투여",
      "doubleCheck": "이중 확인",
      "reconcile": "약물 조정",
      "verbalVerify": "구두 처방 확인",
      "verify": "검증",
      "acknowledge": "확인",
      "prescribe": "처방",
      "dispense": "조제",
      "cancel": "취소",
      "users": "사용자",
      "roles": "역할",
      "facilities": "기관",
      "system": "시스템",
      "audit": "감사 로그"
    }
  },
  "access": {
    "title": "접근 권한 매트릭스",
    "subtitle": "역할 × 권한 그리드",
    "searchPermission": "권한 검색…",
    "searchRole": "역할 검색…",
    "categoryFilter": "카테고리",
    "legend": {
      "own": "직접",
      "inherited": "상속",
      "category": "카테고리",
      "denied": "거부됨",
      "none": "없음"
    },
    "cellTooltip": {
      "hasOwn": "직접 부여됨",
      "hasInherited": "상위 역할에서 상속됨: {{source}}",
      "hasCategory": "카테고리를 통해 부여됨: {{source}}",
      "denied": "명시적으로 거부됨",
      "none": "부여되지 않음"
    },
    "inheritedFrom": "{{source}}에서 상속됨",
    "bulkEdit": {
      "title": "일괄 편집",
      "applyTo": "선택 항목에 적용",
      "selectedPermissions": "권한 {{count}}개",
      "selectedRoles": "역할 {{count}}개",
      "actionGrant": "부여",
      "actionDeny": "거부",
      "actionClear": "지우기",
      "save": "변경사항 저장",
      "cancel": "취소"
    },
    "emptyRoles": "필터 조건과 일치하는 역할이 없습니다.",
    "emptyPermissions": "필터 조건과 일치하는 권한이 없습니다.",
    "loading": "접근 권한 매트릭스를 불러오는 중…",
    "permissionColumn": "권한",
    "rolePicker": {
      "trigger": "비교할 역할 선택",
      "filterPlaceholder": "역할 필터링…",
      "empty": "일치하는 역할이 없습니다.",
      "groupAll": "전체",
      "groupNone": "없음",
      "footerSummary": "{{count}} / {{total}} 개 선택됨",
      "selectAll": "모두 선택",
      "clear": "지우기"
    },
    "empty": {
      "selectRolesPrompt": "비교할 역할을 하나 이상 선택하세요.",
      "selectAllRoles": "모든 역할 선택",
      "noPermissions": "권한을 찾을 수 없습니다."
    },
    "legendCategoryDefault": "카테고리 기본값",
    "legendNotGranted": "부여되지 않음",
    "page": {
      "title": "접근 권한 매트릭스",
      "subtitle": "역할, 권한 및 접근 정책을 보고 관리합니다"
    },
    "tabs": {
      "matrix": "접근 권한 매트릭스",
      "roles": "역할 관리",
      "categories": "카테고리 관리"
    },
    "roles": {
      "searchPlaceholder": "역할 또는 권한 검색...",
      "createButton": "역할 만들기",
      "columns": {
        "role": "역할",
        "category": "카테고리",
        "parent": "상위 역할",
        "permissions": "권한",
        "users": "사용자",
        "actions": "작업"
      },
      "systemBadge": "시스템",
      "managePermissionsTitle": "권한 관리",
      "manageDeniedTitle": "거부 권한 관리",
      "deniedBadge": "거부됨",
      "editTitle": "역할 편집",
      "deleteTitle": "역할 삭제",
      "expandAria": "역할 펼치기",
      "collapseAria": "역할 접기",
      "effectivePermissions": "유효 권한",
      "noPermissionsAssigned": "할당된 권한이 없습니다.",
      "empty": "역할을 찾을 수 없습니다.",
      "delete": {
        "title": "역할 삭제",
        "description": "역할 \"{{name}}\"을(를) 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
        "confirm": "삭제"
      },
      "toast": {
        "deleted": "역할이 삭제되었습니다",
        "deleteError": "역할 삭제에 실패했습니다"
      }
    },
    "categories": {
      "subtitle": "카테고리는 역할을 그룹화하고 공유 정책 (MFA, 세션 제한 등)을 정의합니다.",
      "createButton": "카테고리 만들기",
      "requireMfa": "MFA 필수",
      "yes": "예",
      "no": "아니오",
      "sessionTimeout": "세션 시간 초과",
      "sessionTimeoutMinutes": "{{count}}분",
      "maxFailedLogins": "최대 로그인 실패 횟수",
      "manageDefaults": "기본 권한 관리",
      "editTitle": "편집",
      "editAria": "카테고리 편집",
      "deleteTitle": "삭제",
      "deleteAria": "카테고리 삭제",
      "empty": "아직 정의된 카테고리가 없습니다.",
      "delete": {
        "title": "카테고리 삭제",
        "description": "카테고리 \"{{name}}\"을(를) 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
        "confirm": "삭제"
      },
      "toast": {
        "deleted": "카테고리가 삭제되었습니다",
        "deleteError": "카테고리 삭제에 실패했습니다"
      }
    },
    "confirm": {
      "bulkApply": "{{count}}개의 변경사항을 {{roleCount}}개의 역할에 적용하시겠습니까?",
      "discardChanges": "저장하지 않은 변경사항을 폐기하시겠습니까?"
    },
    "popover": {
      "grantTitle": "권한 부여",
      "denyTitle": "권한 거부",
      "clearTitle": "권한 지우기",
      "grantNote": "이 권한을 부여하면 상속된 거부 설정이 덮어쓰기됩니다.",
      "denyNote": "이 권한을 거부하면 상속된 부여 설정이 덮어쓰기됩니다.",
      "clearNote": "지우면 상속된 동작으로 되돌아갑니다."
    },
    "toast": {
      "permissionGranted": "권한이 부여되었습니다",
      "permissionDenied": "권한이 거부되었습니다",
      "permissionCleared": "권한이 지워졌습니다",
      "bulkApplied": "일괄 변경사항이 적용되었습니다",
      "saveError": "변경사항 저장에 실패했습니다"
    }
  },
  "confirm": {
    "restartIntegration": "\"{{name}}\"을(를) 재시작하시겠습니까? 새 TLS 자료를 불러오는 동안 활성 연결이 잠시 끊깁니다.",
    "revokeFhirEndpoint": "\"{{name}}\"을(를) 취소하시겠습니까? 이 엔드포인트로의 아웃바운드 호출이 중지됩니다.",
    "rotateSmartSecret": "\"{{name}}\"의 클라이언트 시크릿을 교체하시겠습니까? 이전 시크릿은 즉시 작동을 멈춥니다.",
    "revokeSmartApp": "\"{{name}}\"을(를) 취소하시겠습니까? 이 앱의 향후 토큰 요청이 실패합니다.",
    "deactivateThirdPartyApp": "\"{{name}}\"을(를) 비활성화하시겠습니까?"
  },
  "toast": {
    "tierCreated": "등급이 생성되었습니다",
    "tierCloned": "등급이 복제되었습니다",
    "tierDeleted": "등급이 삭제되었습니다",
    "tierStatusUpdated": "상태가 업데이트되었습니다",
    "tierFeaturesUpdated": "기능이 업데이트되었습니다",
    "tierLimitsUpdated": "한도가 업데이트되었습니다",
    "tierSaveError": "등급 생성에 실패하였습니다",
    "tierValidation": "이름과 코드는 필수 항목입니다",
    "licenseKeyGenerated": "라이선스 키가 생성되었습니다",
    "licenseKeyCopied": "라이선스 키가 생성되어 클립보드에 복사되었습니다",
    "overridesSaved": "재정의 항목이 저장되었습니다",
    "pricingConfigSaved": "구성이 저장되었습니다",
    "pricingPriceUpdated": "가격이 업데이트되었습니다",
    "pricingRuleCreated": "가격 규칙이 생성되었습니다",
    "addonUpdated": "추가 모듈이 업데이트되었습니다",
    "invalidNumber": "유효한 숫자를 입력하세요",
    "csvExported": "{{filename}} 내보내기 완료",
    "integrationUpdated": "연동이 업데이트되었습니다",
    "integrationAdded": "연동이 추가되었습니다",
    "integrationInvalidConfig": "구성이 잘못되었습니다 — 호스트/포트와 TLS 필드를 확인하세요",
    "integrationDuplicateName": "같은 이름의 연동이 이미 있습니다",
    "integrationSaveFailed": "연동 저장에 실패했습니다",
    "smartAppRegistered": "SMART 앱이 등록되었습니다",
    "smartAppRegisterFailed": "SMART 앱 등록에 실패했습니다",
    "smartAppUpdated": "SMART 앱이 업데이트되었습니다",
    "smartAppUpdateFailed": "SMART 앱 업데이트에 실패했습니다",
    "fhirEndpointUpdated": "엔드포인트가 업데이트되었습니다",
    "fhirEndpointRegistered": "엔드포인트가 등록되었습니다",
    "fhirEndpointInvalidConfig": "잘못된 구성 — base URL과 auth 필드를 확인하세요",
    "fhirEndpointDuplicateName": "해당 이름의 엔드포인트가 이미 있습니다",
    "fhirEndpointSaveFailed": "엔드포인트 저장에 실패했습니다",
    "clientIdCopied": "Client ID가 복사되었습니다",
    "clientSecretCopied": "Client secret이 복사되었습니다",
    "statusRefreshed": "상태가 새로 고쳐졌습니다",
    "connTestOk": "연결 테스트에 성공했습니다",
    "connTestFailed": "연결 테스트에 실패했습니다 - 엔드포인트 구성을 확인하세요",
    "serverRestarted": "서버가 재시작되었습니다 — 새 TLS 자료가 적용되었습니다",
    "clientReconnected": "클라이언트가 다시 연결되었습니다 — 새 TLS 자료가 적용되었습니다",
    "notRunning": "실행 중이 아님 — 구성을 적용하려면 서버/클라이언트를 시작하세요",
    "restartFailed": "연동 재시작에 실패했습니다",
    "metadataOk": "/metadata 정상{{detail}}",
    "metadataFailed": "/metadata 실패: {{error}}",
    "metadataProbeFailed": "/metadata 프로브에 실패했습니다",
    "metadataUnknownError": "알 수 없음",
    "fhirRevoked": "FHIR 엔드포인트가 취소되었습니다",
    "fhirRevokeFailed": "엔드포인트 취소에 실패했습니다",
    "smartRevoked": "SMART 앱이 취소되었습니다",
    "smartRevokeFailed": "SMART 앱 취소에 실패했습니다",
    "secretRotated": "클라이언트 비밀이 교체되었습니다",
    "rotateSecretFailed": "비밀 교체에 실패했습니다",
    "messageRequeued": "메시지를 재시도하도록 다시 대기열에 넣었습니다",
    "messageRetryFailed": "재시도에 실패했습니다",
    "messageSkipped": "메시지를 건너뛰었습니다 — 대기열이 진행됩니다",
    "messageSkipFailed": "건너뛰기에 실패했습니다",
    "messageAbandoned": "메시지를 포기했습니다",
    "messageAbandonFailed": "포기에 실패했습니다",
    "messageResent": "메시지를 새 메시지로 재전송했습니다",
    "messageResendFailed": "재전송에 실패했습니다",
    "reasonRequired": "사유가 필요합니다",
    "copiedToClipboard": "클립보드에 복사했습니다",
    "thirdPartyAppCreated": "서드파티 앱이 생성되었습니다",
    "thirdPartyAppUpdated": "서드파티 앱이 업데이트되었습니다",
    "thirdPartyAppDeactivated": "서드파티 앱이 비활성화되었습니다",
    "thirdPartyAppLaunchUrl": "실행 URL이 생성되었습니다: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "기관 추가",
      "editTitle": "기관 편집",
      "fields": {
        "name": "이름",
        "code": "코드",
        "type": "유형",
        "address": "주소",
        "city": "도시",
        "stateProvince": "시/도",
        "country": "국가",
        "phone": "전화번호",
        "timeZone": "시간대",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "예: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA 시간대 이름(예: Asia/Singapore). 환자 통계, MAR, 보고서에서 기관 현지 날짜로 사용됩니다."
      },
      "options": {
        "otherIana": "기타(IANA)…",
        "useCuratedList": "추천 목록 사용"
      },
      "errors": {
        "nameMin": "기관 이름은 {{min}}자 이상이어야 합니다",
        "codeFormat": "코드는 대문자와 숫자만 사용할 수 있습니다",
        "typeRequired": "기관 유형은 필수 항목입니다",
        "countryRequired": "국가는 필수 항목입니다",
        "timeZoneRequired": "시간대는 필수 항목입니다",
        "timeZoneInvalidIana": "서버가 이 시간대를 거부하였습니다. 유효한 IANA 이름(예: Asia/Singapore)을 사용해 주십시오.",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "생성",
        "update": "업데이트"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "기관이 생성되었습니다",
        "updatedSuccess": "기관이 업데이트되었습니다",
        "saveError": "기관 저장에 실패하였습니다",
        "invalidTimeZone": "요청이 잘못되었습니다 — 시간대가 유효한 IANA 이름(예: Asia/Singapore)인지 확인해 주십시오."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "시설 관리",
      "subtitle": "시설, 부서 및 (이 트리를 통해) 물리적 위치 계층의 개요. 전체 위치 트리 (건물 → 층 → 단위 → 호실 → 침상)를 보려면 <locationsLink>위치 관리</locationsLink>를 참조하세요.",
      "columns": {
        "name": "이름",
        "code": "코드",
        "type": "유형",
        "address": "주소",
        "phone": "전화",
        "depts": "부서 수",
        "status": "상태",
        "actions": "작업"
      },
      "filter": {
        "search": "시설 검색..."
      },
      "actions": {
        "new": "시설 추가",
        "editTitle": "편집"
      },
      "expand": {
        "expand": "시설 펼치기",
        "collapse": "시설 접기"
      },
      "empty": {
        "noMatch": "검색 조건과 일치하는 시설이 없습니다.",
        "none": "등록된 시설이 없습니다 — 시작하려면 시설 추가를 클릭하세요."
      },
      "departments": {
        "title": "부서",
        "add": "부서 추가",
        "empty": "구성된 부서가 없습니다",
        "locationsCount": "위치 {{count}}개",
        "editTitle": "부서 편집"
      },
      "locations": {
        "title": "위치",
        "add": "추가",
        "empty": "이 부서에 위치가 없습니다. 위치 트리 (건물 → 층 → 단위 → 침상)는 <locationsLink>위치 관리</locationsLink>에서 관리합니다."
      }
    },
    "type": {
      "generalHospital": "종합병원",
      "teachingHospital": "교육병원",
      "specialtyHospital": "전문병원",
      "communityHospital": "지역병원",
      "clinic": "의원"
    },
    "status": {
      "active": "활성",
      "inactive": "비활성"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "헬스 시스템 추가",
      "editTitle": "헬스 시스템 편집",
      "subtitle": "조직 트리의 최상위입니다. 하나 이상의 시설의 상위 조직입니다.",
      "sections": {
        "identity": "기본 정보",
        "primaryContact": "주 연락처",
        "address": "주소"
      },
      "fields": {
        "code": "코드",
        "name": "이름",
        "taxId": "세금 번호",
        "contactName": "이름",
        "contactEmail": "이메일",
        "contactPhone": "전화번호",
        "addressLine1": "주소 1",
        "addressLine2": "주소 2",
        "city": "도시",
        "stateProvince": "시/도",
        "postalCode": "우편번호",
        "country": "국가/지역",
        "active": "활성 — 체크를 해제하면 비활성화됩니다."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "코드는 생성 후 변경할 수 없습니다."
      },
      "errors": {
        "codeRequired": "코드를 입력해 주세요",
        "nameRequired": "이름을 입력해 주세요"
      },
      "submit": {
        "create": "헬스 시스템 생성",
        "update": "변경사항 저장"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "헬스 시스템이 생성되었습니다",
        "updatedSuccess": "헬스 시스템이 업데이트되었습니다",
        "saveError": "헬스 시스템 저장에 실패하였습니다",
        "codeConflict": "이미 존재하는 시스템 코드입니다",
        "invalidData": "헬스 시스템 데이터가 유효하지 않습니다"
      }
    },
    "list": {
      "title": "헬스 시스템",
      "subtitle": "조직 트리의 최상위 — 하나 이상의 시설을 소유하는 엔터프라이즈 / 헬스 시스템 상위 조직. 초기 설정 이후에는 거의 변경되지 않습니다.",
      "columns": {
        "name": "이름",
        "code": "코드",
        "contact": "연락처",
        "location": "위치",
        "facilities": "시설",
        "status": "상태",
        "actions": "작업"
      },
      "filter": {
        "search": "이름 또는 코드로 검색..."
      },
      "actions": {
        "new": "헬스 시스템 추가",
        "editTitle": "편집"
      },
      "status": {
        "active": "활성",
        "inactive": "비활성"
      },
      "empty": {
        "noMatch": "검색 조건과 일치하는 헬스 시스템이 없습니다.",
        "none": "등록된 헬스 시스템이 없습니다 — 시작하려면 헬스 시스템 추가를 클릭하세요."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "위치 추가",
      "editTitle": "위치 편집",
      "subtitle": "물리적 위치 — 건물, 층, 유닛, 병실 또는 병상. FHIR R4 Location 호환. 상위 위치로 중첩하여 계층 트리를 구성합니다.",
      "sections": {
        "hierarchy": "계층",
        "identity": "식별",
        "classification": "분류",
        "physicalAttributes": "물리적 속성"
      },
      "fields": {
        "facility": "시설",
        "parentLocation": "상위 위치",
        "department": "부서(선택)",
        "code": "코드",
        "abbreviation": "약칭",
        "name": "이름",
        "physicalType": "물리적 유형(FHIR)",
        "clinicalType": "임상 유형",
        "status": "상태(FHIR)",
        "operationalStatus": "운영 상태(HL7 0116)",
        "building": "건물",
        "floor": "층",
        "wing": "윈",
        "roomNumber": "병실 번호",
        "bedIdentifier": "병상 식별자",
        "capacity": "수용 인원",
        "active": "활성(레거시 플래그)"
      },
      "placeholders": {
        "facility": "시설 선택…",
        "parentNone": "없음(최상위)",
        "departmentNone": "없음",
        "code": "4W-12-A",
        "name": "4W-12 병상 A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType 값 집합.",
        "clinicalType": "레거시. service_type 도입 시 제거."
      },
      "physicalAttributes": {
        "show": "표시 ▾",
        "hide": "숨김 ▴"
      },
      "errors": {
        "facilityRequired": "시설을 선택해 주세요",
        "codeRequired": "코드를 입력해 주세요",
        "nameRequired": "이름을 입력해 주세요"
      },
      "submit": {
        "create": "위치 생성",
        "update": "변경사항 저장"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "위치가 생성되었습니다",
        "updatedSuccess": "위치가 업데이트되었습니다",
        "saveError": "위치 저장에 실패하였습니다",
        "codeConflict": "이미 존재하는 위치 코드입니다",
        "invalidData": "위치 데이터가 유효하지 않습니다"
      }
    },
    "list": {
      "title": "위치 계층",
      "subtitle": "물리적 트리: 건물 → 층 → 유닛 → 병실 → 병상. FHIR LocationPhysicalType에 정렬됨. 병상 상태 배지를 클릭하면 점유 상태가 순환됩니다. 시설과 부서는 <facilitiesLink>시설</facilitiesLink>에서 관리합니다.",
      "filter": {
        "search": "이름 또는 코드로 검색...",
        "allFacilities": "모든 시설"
      },
      "actions": {
        "new": "위치 추가",
        "addChildTitle": "하위 추가",
        "editTitle": "편집"
      },
      "expand": {
        "expand": "위치 펼치기",
        "collapse": "위치 접기"
      },
      "bed": {
        "toggleTitle": "클릭하여 {{next}}(으)로 전환"
      },
      "empty": {
        "noMatch": "검색과 일치하는 위치가 없습니다.",
        "none": "이 시설에는 아직 위치가 없습니다."
      },
      "toast": {
        "bedStatusUpdated": "병상 상태를 업데이트하였습니다",
        "bedStatusError": "병상 상태 업데이트에 실패하였습니다"
      }
    },
    "type": {
      "si": "사이트",
      "bu": "건물",
      "wi": "동",
      "wa": "병동",
      "lvl": "층",
      "co": "복도",
      "ro": "병실",
      "bd": "병상",
      "ve": "가상",
      "ho": "하우스",
      "ca": "캐비닛",
      "rd": "도로",
      "area": "구역",
      "jdn": "관할구역"
    },
    "clinicalType": {
      "examRoom": "진료실",
      "inpatientBed": "입원 병상",
      "procedureRoom": "처치실",
      "icu": "ICU",
      "ed": "응급",
      "or": "수술실",
      "virtual": "가상"
    },
    "status": {
      "active": "활성",
      "suspended": "일시중지",
      "inactive": "비활성",
      "op": {
        "O": "사용 중",
        "U": "비어 있음",
        "H": "청소 중",
        "K": "오염됨",
        "I": "격리",
        "C": "폐쇄"
      }
    },
    "capability": {
      "isolation": "격리 가능",
      "negativePressure": "음압",
      "bariatric": "비만 환자 가능",
      "telemetry": "원격 모니터링 가능",
      "icu": "ICU 수준"
    }
  },
  "department": {
    "form": {
      "addTitle": "진료과 추가",
      "editTitle": "진료과 편집",
      "subtitle": "시설 내 조직 단위입니다. 상위 진료과를 통해 중첩할 수 있습니다(예: 순환기내과 → 전기생리학 검사실).",
      "sections": {
        "department": "진료과"
      },
      "fields": {
        "facility": "시설",
        "code": "코드",
        "abbreviation": "약어",
        "name": "이름",
        "type": "유형",
        "parentDepartment": "상위 진료과",
        "costCenterCode": "비용 센터 코드",
        "revenueDepartmentCode": "수익 진료과 코드",
        "active": "활성 — 체크를 해제하면 비활성화됩니다."
      },
      "placeholders": {
        "facility": "시설 선택…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "순환기내과",
        "parentNone": "없음(최상위)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "시설을 선택해 주세요",
        "codeRequired": "코드를 입력해 주세요",
        "nameRequired": "이름을 입력해 주세요"
      },
      "submit": {
        "create": "진료과 생성",
        "update": "변경사항 저장"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "진료과가 생성되었습니다",
        "updatedSuccess": "진료과가 업데이트되었습니다",
        "saveError": "진료과 저장에 실패하였습니다",
        "codeConflict": "이미 존재하는 진료과 코드입니다",
        "invalidData": "진료과 데이터가 유효하지 않습니다"
      }
    },
    "serviceType": {
      "clinical": "임상",
      "administrative": "행정",
      "support": "지원"
    },
    "status": {
      "active": "활성",
      "inactive": "비활성"
    }
  },
  "provider": {
    "form": {
      "addTitle": "의료진 추가",
      "editTitle": "의료진 편집",
      "fields": {
        "fullName": "성명",
        "npi": "NPI",
        "providerType": "의료인 유형",
        "credentials": "자격증",
        "specialty": "전문과",
        "email": "이메일",
        "phone": "전화번호",
        "facilityAssignments": "기관 배정",
        "status": "상태",
        "primaryFacility": "주 기관",
        "loginAccount": "로그인 계정"
      },
      "placeholders": {
        "specialty": "전문과 선택…",
        "credentials": "예: MD, FACC",
        "providerType": "의료인 유형 선택",
        "noLoginAccount": "로그인 계정 없음"
      },
      "submit": {
        "create": "생성",
        "update": "업데이트"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "의료진을 추가하였습니다",
        "updatedSuccess": "의료진을 업데이트하였습니다",
        "saveError": "의료진 저장에 실패하였습니다"
      },
      "hints": {
        "loginAccount": "이 임상 담당자를 로그인 계정에 연결합니다. 연결하지 않으면 공동서명, 약사 확인, 위험 결과 확인이 모두 거부됩니다."
      }
    },
    "list": {
      "title": "의료진 관리",
      "subtitle": "의료진, 자격증, 시설 배정을 관리합니다",
      "columns": {
        "name": "성명",
        "npi": "NPI",
        "specialty": "전문 분야",
        "credentials": "자격증",
        "facilities": "시설",
        "status": "상태",
        "actions": "작업"
      },
      "filter": {
        "search": "이름, NPI, 전문 분야로 검색...",
        "allSpecialties": "전체 전문 분야",
        "allFacilities": "전체 시설",
        "allStatus": "전체 상태"
      },
      "actions": {
        "new": "의료진 추가",
        "editTitle": "의료진 편집",
        "scheduleTitle": "스케줄 템플릿",
        "viewCredentials": "자격증 보기"
      },
      "credentials": {
        "licenseLabel": "면허",
        "none": "등록된 자격증이 없습니다"
      },
      "empty": "의료진을 찾을 수 없습니다",
      "pagination": {
        "summary": "{{from}}-{{to}} / {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "이전 페이지",
        "next": "다음 페이지"
      },
      "toast": {
        "schedulePlaceholder": "스케줄 템플릿 링크 (자리표시자)"
      },
      "noLogin": "로그인 없음",
      "noLoginHint": "이 제공자는 연결된 로그인 계정이 없어 공동서명·확인·승인을 할 수 없습니다."
    },
    "specialty": {
      "internalMedicine": "내과",
      "cardiology": "심장내과",
      "emergencyMedicine": "응급의학과",
      "pediatrics": "소아청소년과",
      "pathology": "병리과",
      "obstetricsGynecology": "산부인과",
      "surgery": "외과",
      "orthopedics": "정형외과",
      "neurology": "신경과",
      "psychiatry": "정신건강의학과",
      "radiology": "영상의학과",
      "anesthesiology": "마취통증의학과",
      "oncology": "종양내과",
      "dermatology": "피부과",
      "ophthalmology": "안과"
    },
    "status": {
      "active": "재직",
      "inactive": "비활성",
      "onLeave": "휴직 중"
    },
    "providerType": {
      "physician": "의사",
      "nurse": "간호사",
      "nursePractitioner": "전문간호사",
      "physicianAssistant": "의사보조인력(PA)",
      "pharmacist": "약사",
      "therapist": "치료사",
      "technician": "기사",
      "other": "기타",
      "midwife": "조산사",
      "dentist": "치과의사",
      "pharmacyTechnician": "약제보조원",
      "careAssistant": "간호조무사",
      "dietitian": "영양사",
      "socialWorker": "사회복지사",
      "traditionalMedicine": "전통의학 시술자"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "서비스 라인 추가",
      "editTitle": "서비스 라인 편집",
      "subtitle": "구체적인 임상 서비스를 통할하는 상위 수준의 임상 그룹(순환기, 종양학 등)입니다.",
      "sections": {
        "serviceLine": "서비스 라인"
      },
      "fields": {
        "healthSystem": "보건 시스템",
        "code": "코드",
        "name": "이름",
        "description": "설명",
        "active": "활성 — 체크 해제 시 소프트 비활성화됩니다."
      },
      "placeholders": {
        "healthSystem": "보건 시스템 선택…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "간단한 설명 — 범위, 질환 영역 등."
      },
      "errors": {
        "healthSystemRequired": "보건 시스템은 필수입니다",
        "codeRequired": "코드는 필수입니다",
        "nameRequired": "이름은 필수입니다"
      },
      "submit": {
        "create": "서비스 라인 생성",
        "update": "변경 사항 저장"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "서비스 라인을 생성하였습니다",
        "updatedSuccess": "서비스 라인을 업데이트하였습니다",
        "saveError": "서비스 라인을 저장하지 못하였습니다",
        "codeConflict": "서비스 라인 코드가 이미 존재합니다",
        "invalidData": "서비스 라인 데이터가 유효하지 않습니다"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "임상 서비스 추가",
      "editTitle": "임상 서비스 편집",
      "subtitle": "특정 임상 서비스(순환기내과, EP Lab 등). 선택적으로 서비스 라인 아래에 그룹화하고, 청구 및 디렉터리 출력을 위해 NUCC 전문 코드를 부여할 수 있습니다.",
      "sections": {
        "clinicalService": "임상 서비스",
        "specialtyBilling": "전문 + 청구"
      },
      "fields": {
        "code": "코드",
        "name": "이름",
        "serviceLine": "서비스 라인",
        "description": "설명",
        "specialtyCode": "NUCC 전문 코드",
        "specialtyDescription": "전문 설명",
        "revenueDepartmentCode": "수익 부서 코드",
        "active": "활성"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— 없음 —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC 분류 체계 — 의료진 디렉터리 및 청구 기재에 사용됩니다."
      },
      "errors": {
        "codeRequired": "코드는 필수입니다",
        "nameRequired": "이름은 필수입니다"
      },
      "submit": {
        "create": "임상 서비스 생성",
        "update": "변경 사항 저장"
      },
      "cancel": "취소",
      "toast": {
        "createdSuccess": "임상 서비스를 생성하였습니다",
        "updatedSuccess": "임상 서비스를 업데이트하였습니다",
        "saveError": "임상 서비스를 저장하지 못하였습니다",
        "codeConflict": "임상 서비스 코드가 이미 존재합니다",
        "invalidData": "임상 서비스 데이터가 유효하지 않습니다"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "서비스 ↔ 위치 배정",
    "subtitle": "어떤 임상 서비스가 어떤 물리적 위치에서 운영되는지(선택적 요일/시간대 창 및 수용 능력 포함). 스케줄링이 이를 참조하여 가용 슬롯을 생성합니다. 소프트 삭제만 가능 — 배정을 종료해도 보고서를 위해 이력은 보존됩니다.",
    "header": {
      "newAssignment": "배정 추가",
      "toggleCancel": "취소"
    },
    "form": {
      "title": "새 배정",
      "fields": {
        "service": "임상 서비스",
        "location": "위치",
        "dayOfWeekPattern": "요일 패턴",
        "startTime": "시작 시간",
        "endTime": "종료 시간",
        "capacity": "수용률 %",
        "notes": "메모",
        "isPrimary": "이 서비스의 주요 위치"
      },
      "placeholders": {
        "service": "서비스 선택…",
        "location": "위치 선택…",
        "dayOfWeekPattern": "1,3,5(월/수/금)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "쉼표로 구분된 ISO 요일; 비워두면 매일."
      },
      "errors": {
        "serviceLocationRequired": "서비스와 위치는 필수입니다"
      },
      "create": "생성",
      "cancel": "취소"
    },
    "filter": {
      "allFacilities": "모든 시설",
      "allServices": "모든 서비스",
      "allLocations": "모든 위치",
      "allStatuses": "모든 상태",
      "searchService": "서비스 검색…",
      "searchLocation": "위치 검색…",
      "facility": "시설",
      "serviceLine": "서비스 라인"
    },
    "columns": {
      "service": "서비스",
      "location": "위치",
      "facility": "시설",
      "when": "시간",
      "capacity": "수용 능력",
      "effective": "유효 기간",
      "status": "상태",
      "actions": "작업"
    },
    "status": {
      "active": "활성",
      "planned": "예정",
      "suspended": "일시 중지",
      "ended": "종료됨"
    },
    "dow": {
      "everyDay": "매일",
      "monFri": "월~금",
      "short": {
        "1": "월",
        "2": "화",
        "3": "수",
        "4": "목",
        "5": "금",
        "6": "토",
        "7": "일"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "주요 위치",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "주요로 설정",
      "unsetPrimary": "주요 해제",
      "endAssignment": "배정 종료"
    },
    "bulkEdit": {
      "title": "일괄 편집",
      "applyTo": "선택 항목에 적용",
      "selectedServices": "{{count}}개 서비스",
      "selectedLocations": "{{count}}개 위치",
      "save": "변경 사항 저장",
      "cancel": "취소"
    },
    "confirm": {
      "endTitle": "배정을 종료하시겠습니까?",
      "endDescription": "{{service}} → {{location}}. 종료해도 이력은 보존되지만 이 조합은 활성 스케줄링에서 제외됩니다.",
      "endConfirm": "배정 종료",
      "removeService": "{{location}}에서 {{service}}을(를) 제거하시겠습니까?",
      "makePrimary": "{{location}}을(를) {{service}}의 주요 위치로 지정하시겠습니까?"
    },
    "toast": {
      "created": "배정을 생성하였습니다",
      "createError": "배정 생성에 실패하였습니다",
      "ended": "배정을 종료하였습니다",
      "endError": "배정 종료에 실패하였습니다",
      "primaryError": "주요 전환에 실패하였습니다",
      "updated": "배정을 업데이트하였습니다"
    },
    "empty": "이 필터에 일치하는 배정이 없습니다. ‘배정 추가’를 클릭하여 추가하세요."
  },
  "integration": {
    "list": {
      "title": "연동 관리",
      "subtitle": "HL7, FHIR 및 서드파티 시스템 연동",
      "refresh": "새로 고침",
      "addEndpoint": "엔드포인트 추가",
      "searchPlaceholder": "연동 검색…",
      "tabs": {
        "endpoints": "엔드포인트",
        "messageLog": "메시지 로그",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "엔드포인트 총수",
        "connected": "연결됨",
        "errors": "오류",
        "totalMessages": "메시지 총수"
      }
    },
    "columns": {
      "status": "상태",
      "name": "이름",
      "type": "유형",
      "direction": "방향",
      "url": "URL",
      "tls": "TLS",
      "auth": "인증",
      "lastMessage": "최근 메시지",
      "messages": "메시지 수",
      "errors": "오류 수",
      "backlog": "백로그",
      "health": "상태",
      "actions": "작업",
      "backlogTitle": "미전송 아웃바운드 메시지 + 가장 오래된 대기 메시지 경과 시간",
      "healthTitle": "상태 — 실패한 메시지로 큐가 차단되면 빨간색으로 표시"
    },
    "badge": {
      "tlsCerts": "인증서: {{cert}}, 키: {{key}}, CA: {{ca}}",
      "yes": "예",
      "no": "아니요",
      "basicTitle": "basic({{username}})",
      "bearerStored": "Bearer 토큰 저장됨",
      "bearerNoToken": "bearer(토큰 미설정)",
      "mtlsCert": "mTLS 클라이언트 인증서",
      "awaitingAck": "{{n}}건 ACK 대기 중",
      "oldest": "최고령 {{age}}",
      "never": "없음",
      "blocked": "차단됨",
      "waiting": "대기 중",
      "ok": "정상",
      "blockedTitle": "실패한 메시지가 이 연동의 큐를 차단하고 있습니다. 클릭하여 필터링된 로그를 엽니다.",
      "waitingTitle": "파트너의 향상 모드 앱 ACK를 기다리는 메시지입니다. 클릭하여 필터링된 로그를 엽니다.",
      "okTitle": "모두 정상 — 클릭하여 이 연동의 메시지 로그를 엽니다.",
      "receives": "수신"
    },
    "action": {
      "testConnection": "연결 테스트",
      "restartTls": "재시작 — 새로 교체된 TLS 적용",
      "investigate": "처리량, 지연 시간 및 최근 실패",
      "edit": "편집"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "최근 50개 메시지",
      "columns": {
        "time": "시간",
        "id": "ID",
        "direction": "방향",
        "type": "유형",
        "source": "소스",
        "summary": "요약",
        "status": "상태"
      },
      "dir": {
        "in": "수신",
        "out": "송신"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 서버 상태",
      "serverOnline": "서버 온라인",
      "supportedResources": "지원 리소스",
      "version": "버전",
      "externalHeader": "외부 FHIR 엔드포인트",
      "registerEndpoint": "엔드포인트 등록",
      "columns": {
        "name": "이름",
        "baseUrl": "기본 URL",
        "auth": "인증",
        "status": "상태",
        "lastChecked": "최근 확인",
        "actions": "작업"
      },
      "emptyEndpoints": "등록된 외부 FHIR 엔드포인트가 아직 없습니다.",
      "revoked": "취소됨",
      "statusOk": "정상",
      "statusError": "오류",
      "testMetadata": "/metadata 테스트",
      "edit": "편집",
      "revoke": "취소"
    },
    "smart": {
      "header": "등록된 SMART 앱",
      "registerApp": "앱 등록",
      "columns": {
        "appName": "앱 이름",
        "clientId": "Client ID",
        "scopes": "범위",
        "status": "상태",
        "lastModified": "최근 수정",
        "actions": "작업"
      },
      "emptyApps": "등록된 SMART 앱이 아직 없습니다.",
      "edit": "편집",
      "rotateSecret": "클라이언트 비밀 교체",
      "revoke": "취소"
    },
    "secretModal": {
      "title": "이 client secret을 지금 저장하세요",
      "body": "이 시크릿은 한 번만 표시됩니다. 분실한 경우 시크릿을 회전하여 새로 발급하세요.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID 복사",
      "copyClientSecret": "Client Secret 복사",
      "saved": "저장했습니다"
    },
    "drawer": {
      "header": "연동 #{{id}}",
      "refresh": "새로 고침",
      "close": "닫기",
      "queueBlocked": "큐가 차단됨",
      "queueBlockedBody": "실패한 메시지가 이 연동의 전송을 막고 있습니다. 뒤따르는 메시지는 운영자가 조치할 때까지 대기합니다.",
      "investigate": "조사",
      "tiles": {
        "backlog": "백로그",
        "success24h": "성공률 24h",
        "avgLatency24h": "평균 지연 24h",
        "awaitingAck": "app-ACK 대기"
      },
      "charts": {
        "throughput": "처리량 (24h)",
        "throughputSub": "시간 단위 버킷. 누적: 발신 완료 + 실패, 수신은 보조 축에 표시.",
        "successRate": "성공률 (24h)",
        "successRateSub": "버킷별: 완료 / (완료 + 실패). 빈 구간은 유휴 버킷입니다.",
        "ackLatency": "ACK 지연 (24h)",
        "ackLatencySub": "전송과 ACK 수신 사이의 시간. avg는 실선, p95는 점선."
      },
      "series": {
        "outCompleted": "발신 · 완료",
        "outFailed": "발신 · 실패",
        "inReceived": "수신 · 수신됨",
        "successPct": "성공률 %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "최근 실패",
      "viewAll": "전체 보기 →",
      "noFailures": "최근 구간에 실패한 메시지가 없습니다. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "연결됨",
    "disconnected": "연결 끊김",
    "error": "오류"
  },
  "integrationDirection": {
    "server": "서버",
    "client": "클라이언트"
  },
  "messageStatus": {
    "sent": "전송됨",
    "received": "수신됨",
    "error": "오류",
    "acknowledged": "확인됨"
  },
  "smartAppStatus": {
    "active": "활성",
    "revoked": "취소됨"
  },
  "interfaceMessageStatus": {
    "pending": "대기 중",
    "processing": "처리 중",
    "completed": "완료",
    "received": "수신됨",
    "processed": "처리됨",
    "failed": "실패",
    "error": "오류",
    "rejected": "거부됨",
    "deadLetter": "데드 레터",
    "skipped": "건너뜀",
    "awaitingAppAck": "앱 ACK 대기 중"
  },
  "interfaceDirection": {
    "in": "수신",
    "out": "발신"
  },
  "attemptOutcome": {
    "sent": "전송됨",
    "appNak": "앱 NAK",
    "timeout": "시간 초과",
    "networkError": "네트워크 오류"
  },
  "fhirEndpoint": {
    "titleEdit": "FHIR 엔드포인트 편집",
    "titleRegister": "FHIR 엔드포인트 등록",
    "subtitle": "게이트웨이가 아웃바운드로 통신하는 외부 FHIR R4 파트너입니다. 통합 목록의 Test Connection 버튼은 구성된 auth + TLS로 <code>/metadata</code>를 프로브합니다.",
    "back": "뒤로",
    "cancel": "취소",
    "storedBlank": "저장됨 — 유지하려면 비워 두세요",
    "save": {
      "changes": "변경 사항 저장",
      "register": "엔드포인트 등록"
    },
    "section": {
      "basics": "기본",
      "auth": "인증",
      "tls": "TLS"
    },
    "fields": {
      "name": "이름",
      "baseUrl": "Base URL",
      "description": "설명",
      "active": "활성 — 소프트 해지하려면 선택을 해제하세요.",
      "method": "방식",
      "username": "사용자 이름",
      "password": "비밀번호",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// 가 필요합니다(개발용으로 http://localhost 도 허용됩니다). Test 중에 끝의 /metadata 가 자동으로 추가됩니다.",
      "oauth2": "OAuth2 토큰 가져오기는 관리자 측에 연결되어 있습니다. 런타임 페처는 후속 작업에서 제공됩니다. 지금은 값을 입력하고 나머지 구성을 확인하려면 Test 를 실행하세요.",
      "tls": "파트너의 서버 인증서를 고정하려면 루트 CA를 붙여넣거나, mTLS용 client cert + key를 붙여넣으세요. 잘 알려진 CA의 경우 CA만으로 시스템 루트 저장소와 함께 작동합니다."
    },
    "option": {
      "method": {
        "none": "없음",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — 대부분의 파트너에서는 선택 사항",
      "clientCertRequired": "Client certificate (PEM) — 필수",
      "clientCertMtls": "Client certificate (PEM) — mTLS용",
      "clientKeyRequired": "Client private key (PEM) — 필수",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "이름은 필수입니다",
      "baseUrlRequired": "Base URL은 필수입니다",
      "baseUrlInvalid": "기본 URL은 유효한 http(s) URL이어야 합니다",
      "basicUsername": "Basic auth에는 사용자 이름이 필요합니다",
      "basicPassword": "Basic auth에는 비밀번호가 필요합니다",
      "bearerToken": "Bearer auth에는 token이 필요합니다",
      "clientCertKey": "Client-certificate auth에는 cert + key가 필요합니다"
    }
  },
  "smartApp": {
    "titleEdit": "SMART 앱 편집",
    "titleRegister": "SMART 앱 등록",
    "subtitle": "SMART on FHIR 클라이언트 등록. Client ID는 자동으로 생성됩니다. client secret은 생성 또는 회전 후 한 번만 표시됩니다.",
    "back": "뒤로",
    "cancel": "취소",
    "save": "변경 사항 저장",
    "register": "등록",
    "fields": {
      "appName": "앱 이름",
      "redirectUris": "리디렉션 URI",
      "scopes": "스코프",
      "launchUrl": "실행 URL",
      "logoUrl": "로고 URL",
      "active": "활성 — 체크를 해제하면 이 앱을 소프트 해지합니다."
    },
    "placeholder": {
      "appName": "내 EHR 런처"
    },
    "helper": {
      "redirectUris": "한 줄에 URI 하나씩. https://가 필요합니다(개발용으로 http://localhost도 허용됩니다)."
    },
    "secretModal": {
      "title": "이 client secret을 지금 저장하세요",
      "body": "이 시크릿은 한 번만 표시됩니다. 분실한 경우 시크릿을 회전하여 새로 발급하세요.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID 복사",
      "copyClientSecret": "Client Secret 복사",
      "saved": "저장했습니다"
    },
    "validation": {
      "nameRequired": "이름은 필수입니다",
      "redirectUriRequired": "리디렉션 URI를 하나 이상 입력하세요",
      "scopeRequired": "스코프를 하나 이상 입력하세요"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "인터페이스 메시지 로그",
      "subtitle": "모든 활성 통합의 수신 및 발신 HL7 메시지.",
      "refresh": "새로 고침",
      "loading": "메시지를 불러오는 중…",
      "empty": "현재 필터와 일치하는 메시지가 없습니다.",
      "pagination": "메시지 {{total}}건 • {{pages}}페이지 중 {{page}}페이지",
      "prev": "이전",
      "next": "다음",
      "archived": "(보관됨)"
    },
    "relative": {
      "secondsAgo": "{{n}}초 전",
      "minutesAgo": "{{n}}분 전",
      "hoursAgo": "{{n}}시간 전"
    },
    "filter": {
      "header": "필터",
      "direction": "방향",
      "status": "상태",
      "messageType": "메시지 유형",
      "msh10": "MSH-10 포함",
      "integrationId": "통합 ID",
      "includeArchive": "아카이브 포함",
      "clear": "필터 지우기",
      "any": "모두",
      "messageTypePlaceholder": "예: ADT^A01",
      "controlIdPlaceholder": "제어 ID"
    },
    "columns": {
      "id": "ID",
      "dir": "방향",
      "integ": "통합",
      "type": "유형",
      "msh10": "MSH-10",
      "status": "상태",
      "ack": "ACK",
      "attempts": "시도",
      "when": "시각"
    },
    "detail": {
      "eyebrow": "{{direction}} 메시지",
      "close": "닫기",
      "loading": "불러오는 중…",
      "tabs": {
        "overview": "개요",
        "rawHl7": "원시 HL7",
        "attempts": "시도"
      },
      "operatorActions": "운영자 작업",
      "retry": "재시도",
      "skip": "건너뛰기",
      "abandon": "포기",
      "resendAsNew": "새 메시지로 재전송",
      "skipReason": "건너뛰기 사유",
      "abandonReason": "포기 사유",
      "actionsHelper": "작업은 사용자 ID와 사유와 함께 감사됩니다. 건너뛰기와 포기에는 사유가 필요합니다.",
      "overview": {
        "direction": "방향",
        "integration": "통합",
        "type": "유형",
        "msh10": "MSH-10",
        "status": "상태",
        "ackCode": "ACK 코드",
        "attempts": "시도",
        "created": "생성됨",
        "ackReceived": "ACK 수신",
        "nextRetry": "다음 재시도",
        "ackText": "ACK 텍스트",
        "lastError": "마지막 오류",
        "sourceEventId": "소스 이벤트 ID"
      },
      "rawViewer": {
        "permissionDenied": "복호화된 원시 HL7에는 <code>INTERFACE_OPERATE</code> 권한이 필요합니다.",
        "notAvailable": "이 메시지에 사용 가능한 원시 페이로드가 없습니다.",
        "bytes": "{{bytes}} 바이트",
        "copy": "복사"
      },
      "attempts": {
        "inboundInfo": "시도 기록은 송신 메시지에 대해서만 추적됩니다. 수신 메시지는 MSH-10당 한 번 처리되며, 재전송은 새 시도 없이 캐시된 ACK를 반환합니다.",
        "totalAttempts": "총 시도 횟수",
        "nextAt": " ({{time}}에 다음 시도)",
        "refresh": "새로 고침",
        "loading": "시도를 불러오는 중…",
        "error": "시도를 불러오지 못했습니다.",
        "empty": "아직 기록된 시도가 없습니다. 워커는 전송마다 한 행을 기록하며, 첫 클레임 후 이 목록이 채워집니다.",
        "columns": {
          "when": "일시",
          "outcome": "결과",
          "ack": "ACK",
          "duration": "소요 시간",
          "detail": "세부 정보"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "서드파티 애플리케이션",
      "subtitle": "환자 컨텍스트와 함께 VynaEMR에서 실행할 수 있는 외부 애플리케이션을 구성합니다",
      "addApp": "애플리케이션 추가",
      "searchPlaceholder": "이름, 코드 또는 범주로 앱 검색...",
      "emptyTitle": "구성된 애플리케이션이 없습니다",
      "emptyBody": "PACS 뷰어, 검사 포털 또는 약국 시스템과 같은 외부 애플리케이션을 추가하세요.",
      "columns": {
        "application": "애플리케이션",
        "category": "범주",
        "url": "URL",
        "security": "보안",
        "display": "표시",
        "status": "상태",
        "actions": "작업"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT 서명됨",
      "hmac": "HMAC",
      "hmacSigned": "HMAC 서명됨",
      "none": "없음",
      "chart": "차트",
      "sidebar": "사이드바",
      "active": "활성",
      "inactive": "비활성"
    },
    "action": {
      "testLaunch": "테스트 실행",
      "edit": "편집",
      "deactivate": "비활성화"
    },
    "form": {
      "titleEdit": "애플리케이션 편집",
      "titleNew": "새 애플리케이션",
      "fields": {
        "appCode": "앱 코드",
        "appName": "앱 이름",
        "category": "범주",
        "baseUrl": "기본 URL",
        "launchMethod": "실행 방법",
        "paramMappings": "매개변수 매핑",
        "enableJwt": "JWT 토큰 서명 활성화",
        "sharedSecret": "공유 비밀 (JWT 서명 키)",
        "enableHmac": "URL 서명 활성화 (HMAC)",
        "hmacKey": "HMAC 키",
        "requiredPermission": "필요 권한",
        "displayOrder": "표시 순서",
        "showInChart": "차트에 표시",
        "showInSidebar": "사이드바에 표시"
      },
      "placeholder": {
        "appCode": "예: pacs_viewer",
        "appName": "예: PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL 매개변수 이름",
        "unchanged": "(변경 없음)",
        "sharedSecret": "공유 비밀 입력",
        "hmacKey": "HMAC 키 입력",
        "requiredPermission": "예: RESULT_VIEW (비워두면 모든 사용자)"
      },
      "addParameter": "매개변수 추가",
      "cancel": "취소",
      "submitUpdate": "애플리케이션 업데이트",
      "submitCreate": "애플리케이션 생성"
    },
    "paramSource": {
      "patientMrn": "환자 MRN",
      "patientName": "환자 이름",
      "patientDob": "환자 DOB",
      "encounterId": "진료 ID",
      "encounterNumber": "진료 번호",
      "orderNumber": "오더 번호",
      "userName": "현재 사용자 이름",
      "userId": "현재 사용자 ID",
      "timestamp": "현재 타임스탬프"
    },
    "launch": "{{name}} 실행"
  },
  "integrationForm": {
    "titleEdit": "연동 편집",
    "titleAdd": "연동 추가",
    "subtitle": "VynaHL7 기반의 MLLP 및 HL7-over-HTTP 인터페이스입니다. 인증서 자료는 연동 레코드에 저장되며, 교체는 서버 또는 클라이언트를 다음에 다시 시작할 때 적용됩니다.",
    "back": "뒤로",
    "cancel": "취소",
    "saveChanges": "변경 사항 저장",
    "addIntegration": "연동 추가",
    "storedBlank": "저장됨 — 유지하려면 비워 두세요",
    "selectSibling": "— 동일 계층 연동 선택 —",
    "section": {
      "basics": "기본 정보",
      "connection": "연결",
      "tls": "TLS / mTLS",
      "auth": "인증",
      "ackDelivery": "확인 응답 및 전달",
      "outboundRouting": "송신 라우팅",
      "inboundTrust": "수신 신뢰 수준"
    },
    "fields": {
      "name": "이름",
      "type": "유형",
      "direction": "방향",
      "description": "설명",
      "active": "활성 — 체크 해제 시 이 인터페이스를 소프트 비활성화합니다.",
      "host": "호스트",
      "port": "포트",
      "enableTls": "TLS 사용 — 사용 대상은",
      "serverCert": "서버 인증서(PEM)",
      "clientCert": "클라이언트 인증서(PEM) — mTLS의 경우 선택",
      "serverKey": "서버 개인 키(PEM)",
      "clientKey": "클라이언트 개인 키(PEM)",
      "serverCa": "클라이언트 CA 신뢰 저장소(PEM) — mTLS용",
      "clientCa": "서버 CA 신뢰 저장소(PEM) — 선택, 시스템 루트로 대체",
      "method": "방식",
      "username": "사용자 이름",
      "password": "비밀번호",
      "bearerToken": "Bearer 토큰",
      "inboundAck": "수신 ACK 정책",
      "outboundAck": "송신 ACK 정책",
      "processingTimeout": "처리 제한 시간(밀리초)",
      "pendingAckTtl": "대기 중 ACK TTL(초)",
      "networkRetry": "네트워크 재시도 최대",
      "appNakRetry": "앱 NAK 재시도 최대",
      "reverseIntegration": "역방향 채널 연동",
      "outboundTypes": "수신할 메시지 유형",
      "outboundEvents": "이벤트 단위 구독",
      "receivingApplication": "수신 애플리케이션 (MSH-5)",
      "receivingFacility": "수신 기관 (MSH-6)",
      "inboundTrustProfile": "이 파트너가 할 수 있는 것"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "이 인터페이스에 대한 짧은 메모 — 담당자, 목적, 메시지 유형 등.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "바인드 주소. 모든 인터페이스에서 수신하려면 0.0.0.0을 사용하세요.",
      "hostClient": "이 클라이언트가 연결할 원격 호스트.",
      "tlsHandshake": "을(를) 핸드셰이크에 사용합니다.",
      "authClientCert": "클라이언트 인증서/키는 위의 TLS 섹션에서 가져옵니다.",
      "authNone": "HTTP 인증 헤더가 첨부되지 않습니다.",
      "authRs7": "{{call}}이(가) 이를 모든 송신 요청에 연결합니다.",
      "ackDefaults": "게이트웨이가 수신 HL7 메시지를 어떻게 ACK하고 송신 시 응답 ACK를 어떻게 해석하는지 제어합니다. 기본값",
      "ackDefaultsTail": "은(는) 0.19.0 이전 동작과 일치합니다 — 파트너별로 필요에 따라 변경하세요.",
      "processingTimeout": "동기 앱 ACK 인라인 처리의 상한. 시간 초과 → AE + 백그라운드 큐 재시도.",
      "pendingAckTtl": "향상 모드 앱 ACK 대기 시간으로, 초과 시 스위퍼가 시간 초과 처리합니다.",
      "networkRetry": "큐가 차단되기 전 전송 오류 재시도 횟수.",
      "appNakRetry": "AE/AR/CE/CR 재시도 횟수 — 동일 페이로드는 재시도로 성공하는 경우가 드물어 보통 2~3회.",
      "reverse": "향상 모드는 파트너의 역방향 엔드포인트를 가리키는 동일 계층 연동을 통해 실제 앱 ACK를 전달합니다. 먼저 동일 계층을 별도 연동 레코드로 만든 다음 여기에서 연결하세요.",
      "outboundRouting": "이 파트너가 수신하는 메시지입니다. 아무것도 선택하지 않으면 이 인터페이스는 송신 대상이 아니며 어떤 메시지도 전송되지 않습니다.",
      "outboundEvents": "선택 사항, 쉼표로 구분합니다. 유형 전체보다 좁은 범위로, 특정 이벤트만 필요한 파트너에 사용합니다.",
      "receivingDefaults": "MSH-5와 MSH-6은 여기로 보내는 모든 메시지의 수신자를 나타냅니다. 비워 두면 인터페이스 이름을 사용합니다.",
      "inboundTrust": "이 파트너가 환자 신원에 대해 무엇을 주장할 수 있는지. 인증은 누가 연결하는지를 말하고, 이 설정은 무엇을 알릴 수 있는지를 말합니다. 이 피어가 실제 등록 마스터가 아니라면 배포 기본값을 유지하십시오."
    },
    "option": {
      "type": {
        "mllp": "MLLP(TCP 상의 HL7 v2)",
        "hoh": "HoH(HTTPS 상의 HL7)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "클라이언트(송신)",
        "server": "서버(수신)"
      },
      "method": {
        "none": "없음",
        "basic": "HTTP Basic",
        "bearer": "Bearer 토큰",
        "clientCert": "클라이언트 인증서(mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "즉시 AA(현재 기본값)",
        "honorMsh16": "메시지별로 MSH-15/16 읽기",
        "forceSync": "인라인 처리, 결과에 따라 AA/AE/AR",
        "forceEnhanced": "지금 CA + 역방향 채널을 통한 앱 ACK"
      },
      "outbound": {
        "fireAndForget": "보낸 후 대기하지 않음(현재 기본값)",
        "expectSync": "MSH-16=AL 설정, AE/AR 시 재시도",
        "expectEnhanced": "CA 대기 + 후속 앱 ACK"
      }
    },
    "validation": {
      "nameRequired": "이름은 필수입니다",
      "hostRequired": "호스트는 필수입니다",
      "mllpPort": "MLLP 연동에는 포트가 필요합니다",
      "portNumber": "포트는 숫자여야 합니다",
      "tlsServerCertKey": "TLS 서버에는 인증서와 키가 모두 필요합니다",
      "basicUsername": "Basic 인증에는 사용자 이름이 필요합니다",
      "basicPassword": "Basic 인증에는 비밀번호가 필요합니다",
      "bearerToken": "Bearer 인증에는 토큰이 필요합니다",
      "enhancedReverse": "향상 ACK 모드에는 역방향 연동이 필요합니다 — 아래에서 선택하세요.",
      "outboundEvent": "\"{{value}}\"은(는) 이 시스템이 보내는 메시지가 아닙니다 — ADT 같은 유형이나 ADT^A01 같은 이벤트를 사용하세요."
    },
    "trust": {
      "useDeploymentDefault": "배포 기본값 사용",
      "observer": "관찰자 — 환자를 생성하거나 변경하지 않음",
      "demographics": "인구통계 — 보유 중인 환자를 정정 가능(사망 통지 포함), 생성은 불가",
      "registration": "등록 — 환자 생성 및 차트 병합도 가능"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "영상",
    "laboratory": "검사",
    "pharmacy": "약국",
    "specialty": "전문과",
    "portal": "포털",
    "billing": "청구",
    "other": "기타"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "리디렉션",
    "popup": "팝업 창",
    "iframe": "iframe",
    "newTab": "새 탭"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "CDS 규칙 편집",
      "titleCreate": "CDS 규칙 생성",
      "ruleName": "규칙 이름",
      "ruleType": "규칙 유형",
      "selectPlaceholder": "선택하세요…",
      "severity": "심각도",
      "triggerEvent": "트리거 이벤트",
      "actionType": "작업 유형",
      "description": "설명",
      "active": "활성",
      "cancel": "취소",
      "submitUpdate": "규칙 업데이트",
      "submitCreate": "규칙 생성",
      "createdOk": "규칙이 생성되었습니다",
      "createFailed": "규칙 생성에 실패했습니다",
      "updatedOk": "규칙이 업데이트되었습니다",
      "updateFailed": "규칙 업데이트에 실패했습니다",
      "validation": {
        "nameRequired": "규칙 이름은 필수입니다",
        "typeRequired": "규칙 유형은 필수입니다",
        "descriptionRequired": "설명은 필수입니다",
        "triggerRequired": "트리거 이벤트는 필수입니다",
        "actionRequired": "작업 유형은 필수입니다"
      }
    },
    "list": {
      "title": "CDS 규칙",
      "subtitle": "임상 의사결정 지원 규칙을 관리합니다",
      "addRule": "규칙 추가",
      "loading": "CDS 규칙을 불러오는 중…",
      "loadError": "CDS 규칙을 불러오지 못했습니다.",
      "empty": "구성된 CDS 규칙이 없습니다.",
      "columns": {
        "ruleName": "규칙 이름",
        "type": "유형",
        "severity": "심각도",
        "description": "설명",
        "status": "상태",
        "actions": "작업"
      },
      "toggleActive": "클릭하여 비활성화",
      "toggleInactive": "클릭하여 활성화",
      "active": "활성",
      "inactive": "비활성",
      "editRule": "규칙 편집",
      "statusUpdated": "규칙 상태가 업데이트되었습니다",
      "statusUpdateFailed": "규칙 상태 업데이트에 실패했습니다"
    }
  },
  "cdsSeverity": {
    "info": "정보",
    "warning": "경고",
    "critical": "심각"
  },
  "cdsTriggerEvent": {
    "orderSign": "처방 서명",
    "orderSelect": "처방 선택",
    "patientView": "환자 조회",
    "medicationPrescribe": "약물 처방",
    "resultReceived": "결과 수신",
    "patientAdmit": "환자 입원"
  },
  "cdsActionType": {
    "alert": "경고",
    "warning": "주의",
    "hardStop": "강제 중지",
    "suggestion": "제안",
    "notification": "알림"
  },
  "cdsRuleType": {
    "drugInteraction": "약물 상호작용",
    "drugAllergy": "약물 알레르기",
    "duplicateOrder": "중복 오더",
    "custom": "사용자 지정",
    "clinicalAlert": "임상 경고",
    "sepsisScreen": "패혈증 선별검사"
  },
  "system": {
    "title": "시스템 구성",
    "subtitle": "애플리케이션 설정, 보안 및 시스템 상태",
    "restartServices": "서비스 재시작",
    "restartToast": "서비스 재시작(자리 표시자 - 확인이 필요합니다)",
    "loadError": "시스템 구성 로드 실패",
    "section": {
      "systemInfo": "시스템 정보",
      "systemInfoDesc": "버전, 가동 시간 및 서비스 상태",
      "general": "일반 설정",
      "generalDesc": "애플리케이션 이름, 시간대 및 브랜딩",
      "security": "보안 설정",
      "securityDesc": "비밀번호 정책, MFA 및 세션 관리",
      "notifications": "알림 설정",
      "notificationsDesc": "이메일 및 SMS 게이트웨이 구성",
      "integration": "연동 기본값",
      "integrationDesc": "MLLP, FHIR 및 HL7 기본 구성",
      "featureFlags": "기능 플래그",
      "featureFlagsDesc": "시스템 기능 활성화 또는 비활성화",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "버전",
      "uptime": "가동 시간",
      "database": "데이터베이스",
      "redis": "Redis",
      "microservices": "마이크로서비스",
      "conn": "연결"
    },
    "uptime": {
      "running": "실행 중",
      "unknown": "알 수 없음",
      "up": "실행 중"
    },
    "subsection": {
      "passwordPolicy": "비밀번호 정책",
      "mfa": "다단계 인증",
      "sessionLockout": "세션 및 잠금",
      "emailConfig": "이메일 구성",
      "smsGateway": "SMS 게이트웨이",
      "mllpDefaults": "MLLP 기본값",
      "fhirConfig": "FHIR 구성",
      "hl7Encoding": "HL7 v2 인코딩"
    },
    "fields": {
      "appName": "애플리케이션 이름",
      "timezone": "시간대",
      "dateFormat": "날짜 형식",
      "supportEmail": "지원 이메일",
      "logoUrl": "로고 URL",
      "maintenanceMode": "유지보수 모드(사용자 접근 비활성화)",
      "upload": "업로드",
      "minPasswordLength": "최소 비밀번호 길이",
      "passwordExpiry": "비밀번호 만료(일)",
      "requireUppercase": "대문자 필수",
      "requireNumbers": "숫자 필수",
      "requireSpecialChars": "특수문자 필수",
      "enableMfa": "MFA 활성화",
      "mfaMethod": "MFA 방식",
      "sessionTimeout": "세션 시간 초과(분)",
      "maxLoginAttempts": "최대 로그인 시도 횟수",
      "lockoutDuration": "잠금 기간(분)",
      "smtpHost": "SMTP 호스트",
      "smtpPort": "SMTP 포트",
      "smtpUser": "SMTP 사용자",
      "fromEmail": "발신 이메일",
      "useTls": "TLS 사용",
      "enabled": "사용",
      "provider": "공급자",
      "fromNumber": "발신 번호",
      "defaultPort": "기본 포트",
      "timeoutSeconds": "시간 초과(초)",
      "retryCount": "재시도 횟수",
      "fhirBaseUrl": "FHIR 기본 URL",
      "authMethod": "인증 방식",
      "fieldSeparator": "필드 구분자",
      "encodingChars": "인코딩 문자",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "아시아/싱가포르(UTC+8)",
        "hongKong": "아시아/홍콩(UTC+8)",
        "kualaLumpur": "아시아/쿠알라룸푸르(UTC+8)",
        "bangkok": "아시아/방콕(UTC+7)",
        "tokyo": "아시아/도쿄(UTC+9)",
        "kolkata": "아시아/콜카타(UTC+5:30)",
        "sydney": "오스트레일리아/시드니(UTC+11)"
      },
      "mfa": {
        "totp": "TOTP(인증 앱)",
        "sms": "SMS",
        "email": "이메일"
      },
      "fhirAuth": {
        "none": "없음",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "일반 설정 저장",
      "security": "보안 설정 저장",
      "notifications": "알림 설정 저장",
      "integration": "연동 설정 저장",
      "features": "기능 플래그 저장",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "일반",
      "security": "보안",
      "notifications": "알림",
      "integration": "연동",
      "features": "기능 플래그",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "로고 업로드(자리 표시자)",
      "saved": "{{section}} 설정이 저장되었습니다",
      "saveFailed": "설정 저장 실패"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "환자 병합",
        "description": "환자 병합/병합 해제 기능 활성화"
      },
      "breakGlass": {
        "label": "긴급 접근",
        "description": "제한된 기록에 대한 긴급 재정의 허용"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "외부 시스템용 FHIR R4 엔드포인트 노출"
      },
      "smartApps": {
        "label": "SMART on FHIR 앱",
        "description": "타사 SMART 앱 연결 허용"
      },
      "clinicalDecisionSupport": {
        "label": "임상 의사결정 지원",
        "description": "오더 입력에 CDS 훅 활성화"
      },
      "telemedicine": {
        "label": "원격의료 모듈",
        "description": "화상 진료 및 원격 모니터링"
      },
      "patientPortal": {
        "label": "환자 포털",
        "description": "환자용 기록 및 예약 포털"
      },
      "analyticsDashboard": {
        "label": "분석 대시보드",
        "description": "고급 분석 및 보고 대시보드"
      },
      "medicationBarcode": {
        "label": "약품 바코드 스캔",
        "description": "투약 관리용 바코드 검증"
      },
      "autoCoding": {
        "label": "자동 코딩(ICD/CPT)",
        "description": "AI 지원 진단 및 시술 코딩"
      }
    }
  },
  "audit": {
    "title": "감사 로그",
    "subtitle": "상세 변경 추적이 포함된 시스템 활동 로그",
    "exportCsv": "CSV 내보내기",
    "exportToast": "{{count}}개의 감사 항목을 CSV로 내보내는 중 (자리 표시자)",
    "searchPlaceholder": "사용자로 검색…",
    "advanced": "고급",
    "breakGlassOnly": "긴급 접근만",
    "fromTo": "시작 / 종료:",
    "fromDate": "시작일",
    "toDate": "종료일",
    "clearFilters": "모든 필터 지우기",
    "entriesFound": "{{count}}개의 항목을 찾았습니다",
    "noMatch": "필터 조건과 일치하는 감사 항목이 없습니다",
    "viewDetails": "세부정보 보기",
    "detail": {
      "title": "감사 항목 세부정보",
      "timestamp": "타임스탬프",
      "user": "사용자",
      "action": "작업",
      "resource": "리소스",
      "ipAddress": "IP 주소",
      "breakGlass": "긴급 접근",
      "yes": "예",
      "no": "아니요",
      "details": "세부정보",
      "dataChanges": "데이터 변경",
      "before": "변경 전",
      "after": "변경 후",
      "result": "결과"
    },
    "columns": {
      "timestamp": "타임스탬프",
      "user": "사용자",
      "action": "작업",
      "resource": "리소스",
      "resourceId": "리소스 ID",
      "ipAddress": "IP 주소",
      "details": "세부정보",
      "view": "보기"
    },
    "filter": {
      "action": {
        "all": "모든 작업",
        "create": "생성",
        "read": "조회",
        "update": "수정",
        "delete": "삭제",
        "login": "로그인",
        "logout": "로그아웃",
        "export": "내보내기",
        "breakGlass": "긴급 접근"
      },
      "resource": {
        "all": "모든 리소스",
        "patient": "환자",
        "encounter": "진료",
        "order": "오더",
        "result": "결과",
        "medication": "투약",
        "user": "사용자",
        "system": "시스템"
      }
    },
    "pagination": {
      "first": "처음",
      "last": "마지막",
      "pageOf": "{{pages}} 페이지 중 {{page}} 페이지",
      "range": "총 {{total}}개 중 {{from}}-{{to}}"
    }
  },
  "taxonomy": {
    "title": "임상 분류 체계",
    "subtitle": "서비스 라인은 관련 임상 서비스를 그룹화합니다(Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). 두 가지 모두 스케줄링에 사용되는 서비스 ↔ 위치 배정 매트릭스에 반영됩니다.",
    "addServiceLine": "서비스 라인 추가",
    "addClinicalService": "임상 서비스 추가",
    "tabs": {
      "serviceLines": "서비스 라인",
      "clinicalServices": "임상 서비스"
    },
    "searchLines": "서비스 라인 검색...",
    "searchServices": "임상 서비스 검색...",
    "empty": {
      "linesNone": "구성된 서비스 라인이 없습니다.",
      "linesNoMatch": "일치하는 서비스 라인이 없습니다.",
      "servicesNone": "구성된 임상 서비스가 없습니다.",
      "servicesNoMatch": "일치하는 임상 서비스가 없습니다."
    },
    "columns": {
      "name": "이름",
      "code": "코드",
      "description": "설명",
      "services": "서비스",
      "status": "상태",
      "serviceLine": "서비스 라인",
      "specialty": "전문 분야",
      "actions": "작업"
    },
    "status": {
      "active": "활성",
      "inactive": "비활성"
    },
    "editTitle": "편집"
  },
  "systemStatus": {
    "connected": "연결됨",
    "error": "오류"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}}명 배정",
      "unstaffedBadge": "담당자 없음",
      "unstaffedWarning": "다음 역할에는 담당자가 없어 해당 단계에서 아무도 호출되지 않습니다: {{roles}}. 관리 → 사용자에서 역할을 배정하세요."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
